import { render, staticRenderFns } from "./DownloadAppModal.vue?vue&type=template&id=1bd46bfa"
import script from "./DownloadAppModal.vue?vue&type=script&lang=ts"
export * from "./DownloadAppModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports